import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getIsMobile } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { AppState } from '../../types/store';
import {
  getActiveSection,
  getHasResults,
  getSelectedFolder,
  getDuperbrowseStreamVersion,
} from '../../selectors/studio';
import { Props } from './Studio';

export type StateProps = Pick<
  Props,
  'activeSection' | 'selectedFolder' | 'hasDeviations' | 'isMobile' | 'duperbrowseStreamVersion'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  activeSection: getActiveSection(state),
  selectedFolder: getSelectedFolder(state),
  hasDeviations: getHasResults(state),
  isMobile: getIsMobile(state),
  duperbrowseStreamVersion: getDuperbrowseStreamVersion(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
